import React from 'react'
import './intro.css'
import img from "../../image/profile.png"
import { IoMdCall } from "react-icons/io"
import Typewriter from 'react-typewriter-effect';

const Intro = () => {
    console.log(window.innerWidth);
    return (
        <div className="intro">
            <div className="introbox">
                <div className="i_left">
                    <span>Welcome to my world</span>
                    <span>Hi,I'm Gulshan Sharma</span>
                    <span>
                        <Typewriter
                            textStyle={{
                                fontFamily: 'Red Hat Display',
                                color: '#f9004d',
                                fontWeight: 700,
                                fontSize: '75px',
                            }}
                            hideCursor={true}
                            trackWidth={50}
                            startDelay={2000}
                            cursorColor="transparent"
                            multiText={['Full Stack Developer.', 'Front End Developer.', 'Tech Enthusiast.']}
                            multiTextDelay={1000}
                            typeSpeed={30}
                            multiTextLoop
                        />

                    </span>
                    <span className="mobileType">
                        <Typewriter
                            textStyle={{
                                fontFamily: 'Red Hat Display',
                                color: '#f9004d',
                                fontWeight: 700,
                                fontSize: '45px',
                            }}
                            hideCursor={true}
                            trackWidth={50}
                            startDelay={2000}
                            cursorColor="transparent"
                            multiText={['Full Stack Developer.', 'Front End Developer.', 'Tech Enthusiast.']}
                            multiTextDelay={1000}
                            typeSpeed={30}
                            multiTextLoop
                        />

                    </span>
                    <span>Based in India.</span>
                    <div className="btn"><a href="https://drive.google.com/file/d/1V4rG08eHfcqg0Dk8HTV4gdWC2ZaGYcsO/view" target={"_blank"}>Resume</a></div>
                </div>
                <div className="i_right">
                    <div><a href="tel:9315318116"><IoMdCall /></a></div>
                    <img src={img} width="350px" alt="Profile" />
                </div>
            </div>
        </div >
    )
}

export default Intro;